import * as e from "react";
import c from "../lib/IconBase.es.js";
import t from "../defs/CirclesThreePlus.es.js";
const r = e.forwardRef((o, s) => /* @__PURE__ */ e.createElement(c, { ref: s, ...o, weights: t }));
r.displayName = "CirclesThreePlusIcon";
const l = r;
export {
  l as CirclesThreePlus,
  r as CirclesThreePlusIcon
};
